import { render } from "./TableRow.vue?vue&type=template&id=00778aa8"
import script from "./TableRow.vue?vue&type=script&lang=js"
export * from "./TableRow.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TableRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00778aa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00778aa8', __exports__)) {
    api.reload('00778aa8', __exports__)
  }
  
  module.hot.accept("./TableRow.vue?vue&type=template&id=00778aa8", () => {
    api.rerender('00778aa8', render)
  })

}


export default __exports__